import React from 'react';
import { Image, useComputedColorScheme } from '@mantine/core';

interface Props {
  size?: number | string;
}

export const QDocLogo: React.FC<Props> = ({ size = 48 }) => {
  const computedColorScheme = useComputedColorScheme('dark');

  return (
    <Image
      src={`/q-crop-${computedColorScheme}.png`}
      alt="QDoc Logo"
      w={size}
      h={size}
      data-testid="login-logo"
      style={{
        alignSelf: 'center'
      }}
    />
  );
};
